export default __webpack_public_path__ + "static/media/carol-nutri-maca.646df6c3.jpg";